<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="问诊调查表名称">
          <el-input placeholder="请输入问诊调查表名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加问诊调查表</el-button>

      <div style="margin-top: 10px;">同一个医生多个问诊调查表 每次只生效最新的一个</div>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="hques_id" label="ID"></el-table-column>

  
            <el-table-column prop="name" label="问诊调查表名称"></el-table-column>

            <el-table-column prop="doctor.name" label="所属医生"></el-table-column>


            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="190">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" style="margin-left: 0px !important;" type="text" size="small">编辑</el-button>
                <el-button @click="copyClick(scope.row)" style="margin-left: 0px !important;" type="text" size="small">复制</el-button>
                <!-- <el-button @click="subClick(scope.row)" style="margin-left: 0px !important;" type="text" size="small">提交的问诊调查表</el-button> -->
                <el-button @click="deleteClick(scope.row)" style="margin-left: 0px !important;" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :hques_id="hques_id"  v-if="open_edit"   @close="closeEdit"></Edit>


    <Tz :open_add="open_tz" :code="code" :hques_id="hques_id" :obj="obj"  v-if="open_tz"   @close="closeTz"></Tz>
  <Sub :open_index="open_index"  :hques_id="hques_id" :obj="obj"  v-if="open_index"   @close="closeIndex"></Sub>
  </div>
</template>

<script>
  import HquesApi from '@/api/hques.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Tz from './part/tz.vue';
  import Sub from './hquessub/index.vue';
  export default {
    components: {
      Add,
      Edit,
      Tz,
      Sub
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        hques_id:"",
        dialogVisible:false,
        open_tz:false,
        hques_id:0,
        open_index:false,

      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
      
    },
    methods: {
      closeIndex(){
          this.open_index = false;
      },
      subClick(row){
        this.open_index=true;
        console.log(row.hques_id);
        console.log( this.open_index);
        this.obj = row
        this.hques_id = row.hques_id;
      },
      introClick(row,code){
        this.open_tz=true;
        this.obj = row
        this.code = code
        this.hques_id = row.hques_id;
      },
      closeTz(e){
      this.open_tz=false;

      this.getTableList();
    },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//问诊调查表标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        HquesApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.hques_id = row.hques_id;
        this.open_edit = true
      },
      copyClick(row) {
        let self = this;
        self
          .$confirm('是否复制该问诊调查表表?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            HquesApi.copy(
              {
                hques_id: row.hques_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '复制成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            HquesApi.del(
              {
                hques_id: row.hques_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/hospital/hques/index/index.vue